import { moviesA } from "@/mocks/moviesA";
import { moviesB } from "@/mocks/moviesB";

export interface MovieNews {
  title: string;
  date: string;
}

export interface Movie {
  id: string;
  title: string;
  year: number;
  releaseDate: string;
  region: string;
  types: string[];
  director: string;
  cast: string[];
  duration: number;
  rating: number;
  views: number;
  poster: string;
  summary: string;
  synopsis: string;
  news: MovieNews[];
}

export const movies: Movie[] = [...moviesA, ...moviesB];

export interface CategoryMeta {
  slug: string;
  type: string;
  name: string;
  en: string;
  icon: string;
  description: string;
}

export const categories: CategoryMeta[] = [
  {
    slug: "action",
    type: "动作",
    name: "动作电影",
    en: "Action",
    icon: "ri-sword-line",
    description: "追逐、格斗与极限营救，汇集最新动作电影动态与高热度作品推荐。",
  },
  {
    slug: "drama",
    type: "剧情",
    name: "剧情电影",
    en: "Drama",
    icon: "ri-book-open-line",
    description: "从人物命运到时代切片，关注细腻叙事与真实情感的表达。",
  },
  {
    slug: "scifi",
    type: "科幻",
    name: "科幻电影",
    en: "Sci-Fi",
    icon: "ri-planet-line",
    description: "深空、未来与人工智能，追踪科幻电影的世界观与视效新动向。",
  },
  {
    slug: "comedy",
    type: "喜剧",
    name: "喜剧电影",
    en: "Comedy",
    icon: "ri-emotion-happy-line",
    description: "轻松解压的喜剧新片与经典笑点合集，适合全家一起观看。",
  },
  {
    slug: "mystery",
    type: "悬疑",
    name: "悬疑电影",
    en: "Mystery",
    icon: "ri-search-eye-line",
    description: "罪案、推理与反转，整理高口碑悬疑片单与幕后资讯。",
  },
  {
    slug: "animation",
    type: "动画",
    name: "动画电影",
    en: "Animation",
    icon: "ri-palette-line",
    description: "手绘、三维与作者动画，关注国内外动画长片的创作与上映。",
  },
  {
    slug: "romance",
    type: "爱情",
    name: "爱情电影",
    en: "Romance",
    icon: "ri-heart-3-line",
    description: "相遇、告别与重逢，收录爱情电影的口碑佳作与情感解读。",
  },
  {
    slug: "adventure",
    type: "冒险",
    name: "冒险电影",
    en: "Adventure",
    icon: "ri-compass-3-line",
    description: "荒野、雪线与人迹罕至之地，跟随镜头出发去往更远的地方。",
  },
];

export const regions = ["全部地区", "中国大陆", "中国香港", "美国", "日本", "韩国", "英国", "法国"];
export const years = ["全部年份", "2026", "2025", "2024", "2023"];
export const PAGE_SIZE = 12;

export const hotKeywords = ["悬疑", "科幻", "动画", "陈默", "深空回声", "剧情"];

export interface HeroSlide {
  movieId: string;
  tag: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    movieId: "m02",
    tag: "本周焦点",
    image:
      "https://readdy.ai/api/search-image?query=astronaut%20silhouette%20before%20immense%20glowing%20ringed%20planet%2C%20stylized%20cinematic%20key%20art%2C%20deep%20navy%20space%20with%20warm%20amber%20light%20rays%2C%20volumetric%20haze%2C%20epic%20scale%2C%20no%20text&width=1920&height=1080&seq=hero-slide-01&orientation=landscape",
  },
  {
    movieId: "m21",
    tag: "新片定档",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20snow%20mountain%20ridge%20at%20dusk%20with%20tiny%20climber%20silhouettes%20and%20distant%20helicopter%20beam%2C%20cinematic%20wide%20key%20art%2C%20deep%20navy%20shadows%20and%20warm%20amber%20alpenglow%2C%20no%20text&width=1920&height=1080&seq=hero-slide-02&orientation=landscape",
  },
  {
    movieId: "m05",
    tag: "口碑佳作",
    image:
      "https://readdy.ai/api/search-image?query=foggy%20harbor%20at%20night%20with%20lone%20detective%20silhouette%20and%20distant%20cargo%20ship%2C%20stylized%20cinematic%20key%20art%2C%20deep%20navy%20fog%20and%20warm%20amber%20dock%20lamps%2C%20moody%20atmosphere%2C%20no%20text&width=1920&height=1080&seq=hero-slide-03&orientation=landscape",
  },
  {
    movieId: "m31",
    tag: "动画推荐",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20night%20sky%20over%20old%20railway%20with%20golden%20comet%20trail%20and%20tiny%20traveler%20silhouette%2C%20cinematic%20animated%20key%20art%2C%20deep%20navy%20cosmos%20and%20warm%20amber%20glow%2C%20no%20text&width=1920&height=1080&seq=hero-slide-04&orientation=landscape",
  },
];

export const siteInfo = {
  name: "秋霞电影",
  en: "QIU XIA FILMS",
  slogan: "看电影，从一个可靠的消息源开始",
  description:
    "秋霞电影是一个影视内容聚合平台，整合最新电影资讯、片单推荐与影片资料，覆盖动作、剧情、科幻、喜剧、悬疑、动画、爱情、冒险等多种类型，帮助影迷快速了解电影动态、找到想看的作品。",
  email: "contact@qiuxia-movie.com",
  since: "2016",
};

export function getMovieById(id: string | undefined): Movie | undefined {
  if (!id) return undefined;
  return movies.find((movie) => movie.id === id);
}

export function getCategoryBySlug(slug: string | undefined): CategoryMeta | undefined {
  return categories.find((category) => category.slug === slug);
}

export function getCategorySlug(type: string): string {
  const matched = categories.find((category) => category.type === type);
  return matched ? matched.slug : "drama";
}

export function getCategoryCount(type: string): number {
  return movies.filter((movie) => movie.types.includes(type)).length;
}

export function getMoviesByType(type: string): Movie[] {
  return movies.filter((movie) => movie.types.includes(type));
}

export function sortMovies(list: Movie[], sort: string): Movie[] {
  const next = [...list];
  if (sort === "popular") {
    next.sort((a, b) => b.views - a.views);
  } else if (sort === "rating") {
    next.sort((a, b) => b.rating - a.rating);
  } else {
    next.sort((a, b) => (a.releaseDate < b.releaseDate ? 1 : -1));
  }
  return next;
}

export interface FilterOptions {
  type?: string;
  region?: string;
  year?: string;
  sort?: string;
}

export function filterMovies(options: FilterOptions): Movie[] {
  const { type, region = "全部地区", year = "全部年份", sort = "latest" } = options;
  const list = movies.filter((movie) => {
    if (type && !movie.types.includes(type)) return false;
    if (region !== "全部地区" && movie.region !== region) return false;
    if (year !== "全部年份" && String(movie.year) !== year) return false;
    return true;
  });
  return sortMovies(list, sort);
}

export function searchMovies(keyword: string): Movie[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return movies.filter((movie) => {
    const haystack = [movie.title, movie.director, movie.region, ...movie.types, ...movie.cast]
      .join(" ")
      .toLowerCase();
    return haystack.includes(key);
  });
}

export function getRelatedMovies(movie: Movie, limit = 6): Movie[] {
  const scored = movies
    .filter((item) => item.id !== movie.id)
    .map((item) => {
      let score = 0;
      item.types.forEach((type) => {
        if (movie.types.includes(type)) score += 2;
      });
      if (item.director === movie.director) score += 5;
      if (item.region === movie.region) score += 1;
      return { item, score };
    })
    .filter((entry) => entry.score > 0)
    .sort((a, b) => b.score - a.score || b.item.rating - a.item.rating);
  return scored.slice(0, limit).map((entry) => entry.item);
}

export function getHotMovies(limit = 8): Movie[] {
  return [...movies].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestMovies(limit = 8): Movie[] {
  return sortMovies(movies, "latest").slice(0, limit);
}

export interface NewsItem {
  title: string;
  date: string;
  movieId: string;
  movieTitle: string;
}

export function getNewsFeed(limit = 6): NewsItem[] {
  const all: NewsItem[] = movies.flatMap((movie) =>
    movie.news.map((item) => ({
      title: item.title,
      date: item.date,
      movieId: movie.id,
      movieTitle: movie.title,
    })),
  );
  return all.sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, limit);
}

export function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)} 万`;
  return `${views}`;
}